import { TFunction } from 'i18next';
import { URL_ESTOY_SIN_LUZ } from 'navigation';
import AnalyticsService from 'services/AnalyticsService';
import { ETIQUETA_A_LAS, formatInfoActualizada, TIPO_FECHA_VACIO } from 'utils/formatters/dateFormatter';
import { EventosGtmSaesa } from 'utils/GtmEvents';
import {
  COLOR_RECUPERADO_FIN,
  COLOR_RECUPERADO_INICIO,
  COLOR_SIN_SERVICIO_FIN,
  COLOR_SIN_SERVICIO_INICIO,
  DESTINO_VENTANA_NUEVA,
  INDICE_CORTE_CONFIRMADO,
  NOMBRE_SECTOR_RECUPERADO,
  NOMBRE_SECTOR_SIN_SERVICIO,
  REL_VENTANA_SEGURA,
} from './outageDashboard.constants';

/**
 * Etiquetas de hoy/mañana/a las para formatTerDisplay.
 * @param t traductor i18n
 * @returns labels de fecha relativa
 */
export const buildTerLabels = (t: TFunction) => ({
  hoy: t('desconexion:paginas.mapaCortes.modalTracking.fechas.hoy'),
  manana: t('desconexion:paginas.mapaCortes.modalTracking.fechas.manana'),
  aLas: t('desconexion:paginas.mapaCortes.modalTracking.dashboard.ter.aLas', { defaultValue: ETIQUETA_A_LAS }),
});

/**
 * Texto del pie de última actualización del dashboard.
 * @param fechaActualizacion fecha de actualización del mapa
 * @param t traductor i18n
 * @returns texto listo para el footer
 */
export const buildFooterTexto = (fechaActualizacion: string | null | undefined, t: TFunction): string => {
  const footerActualizacion = formatInfoActualizada(fechaActualizacion, {
    hoyALas: hora => t('desconexion:paginas.mapaCortes.texts.ultimaActualizacionHoy', { hora }),
    alFecha: fecha =>
      `${t('desconexion:paginas.mapaCortes.modalTracking.disclaimer.imprevistos.subTitulo')}${fecha} ${t(
        'desconexion:paginas.mapaCortes.modalTracking.disclaimer.imprevistos.fechaHoras'
      )}`,
  });
  return footerActualizacion.kind !== TIPO_FECHA_VACIO ? footerActualizacion.texto : t('desconexion:paginas.mapaCortes.texts.disclaimer');
};

/**
 * Registra el evento GTM y abre Estoy sin luz en una pestaña nueva.
 */
export const abrirEstoySinLuz = (): void => {
  AnalyticsService.enviarTag(EventosGtmSaesa.mapaDesconexiones.reportarCorte);
  window.open(URL_ESTOY_SIN_LUZ, DESTINO_VENTANA_NUEVA, REL_VENTANA_SEGURA);
};

export type SectorGrafico = { name: string; value: number };
export type ColorGradiente = { start: string; end: string };

/**
 * Sectores y colores del pie de clientes afectados.
 * @param porcentajeSin porcentaje aún sin servicio
 * @param porcentajeRec porcentaje recuperados
 * @returns data y colores del gráfico
 */
export const buildDatosGraficoClientes = (
  porcentajeSin?: string | null,
  porcentajeRec?: string | null
): { objetoGrafico: SectorGrafico[]; colores: ColorGradiente[] } => {
  const pctSin = Number(porcentajeSin);
  const pctRec = Number(porcentajeRec);
  return {
    objetoGrafico: [
      { name: NOMBRE_SECTOR_SIN_SERVICIO, value: Number.isFinite(pctSin) ? pctSin : INDICE_CORTE_CONFIRMADO },
      { name: NOMBRE_SECTOR_RECUPERADO, value: Number.isFinite(pctRec) ? pctRec : INDICE_CORTE_CONFIRMADO },
    ],
    colores: [
      { start: COLOR_SIN_SERVICIO_INICIO, end: COLOR_SIN_SERVICIO_FIN },
      { start: COLOR_RECUPERADO_INICIO, end: COLOR_RECUPERADO_FIN },
    ],
  };
};
